/** @type {AbortController | undefined} */
let controller;

// Init for the first time this function is called every time swatch is selected on PDP
// see: color-swatches-pdp.js:266
initProductThumbnailJS();

function initProductThumbnailJS() {
  if (controller) controller.abort();
  controller = new AbortController();

  let $productImageSection;
  let $thumbnailSection;

  let mainImageAreaTopPosition;
  let singleImageHeight;
  let thumbImageAreaHeight;
  let thumbnailPositionTop;
  let productImages;

  function setThumbnailData() {
    $productImageSection = document.querySelector('slider-component.custom-media-desktop');
    $thumbnailSection = document.querySelector('.product-thumbnail_section_desktop');

    mainImageAreaTopPosition = $productImageSection.getBoundingClientRect().top + window.scrollY;
    const singleImage = $productImageSection.querySelector(
      '.product__media-list li[data-image-index="0"] .product-media-container .product__media img'
    );
    singleImageHeight = singleImage ? singleImage.clientHeight : 0;
    productImages = $productImageSection.querySelectorAll('.product__media-list li');

    thumbImageAreaHeight = $thumbnailSection ? $thumbnailSection.clientHeight + 4.3 : 0;
    thumbnailPositionTop =  $thumbnailSection ? $thumbnailSection.getBoundingClientRect().top + window.scrollY : 0;
  }

  const elProductInfoLeft = document.querySelector('.product-information-left');
  function checkLeftInfoAsset(thumbnailBottom) {
    if (!elProductInfoLeft) return;
    if (elProductInfoLeft.getBoundingClientRect().top > thumbnailBottom) {
      $thumbnailSection.style.opacity = '';
    } else {
      $thumbnailSection.style.opacity = '0';
    }
  }

  setThumbnailData();

  let scrollTopBigContent = 0;
  let movingContentTop = 0;

  const elSelectionMarker = document.querySelector('.selection-marker');
  const elThumbnail = document.querySelector('.product-thumbnail_section_desktop');
  maxMarkerTop = elSelectionMarker ? thumbImageAreaHeight - elSelectionMarker.clientHeight : 0;


  function updateMarker() {
    const mainImageAreaHeight = singleImageHeight * productImages.length;
    if(!$thumbnailSection){
      return;
    }
    scrollTopBigContent = $thumbnailSection.getBoundingClientRect().top + window.scrollY - mainImageAreaTopPosition;

    if (scrollTopBigContent > 0) {
      movingContentTop = (thumbImageAreaHeight * scrollTopBigContent) / mainImageAreaHeight - 12; // 12 is the margin around the thumbnail
      elSelectionMarker.style.top = `${Math.min(maxMarkerTop, movingContentTop)}px`;
    }

    checkLeftInfoAsset(elThumbnail.getBoundingClientRect().bottom + 32);
  }

  updateMarker();
  window.addEventListener('scroll', throttle(updateMarker, 32), { signal: controller.signal });

  /**
   * Thumbnail click
   */
  document.querySelectorAll('.product-thumbnail_section_desktop a').forEach((el) => {
    el.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const imageIndex = this.getAttribute('data-thumb-index');

        const img = document.querySelector(
          'slider-component.custom-media-desktop .product__media-list li[data-image-index="0"] .product-media-container .product__media img'
        );
        const imgHeight = img ? img.clientHeight : 0;

        const headerHeight =
          document.querySelector('.top-bar-red').offsetHeight +
          document.querySelector('.announcement-bar-section').offsetHeight;

        let scrollPosition = imageIndex * imgHeight + headerHeight + imageIndex * 5; // 5 is the margin between images

        if (window.scrollY < scrollPosition) {
          scrollPosition += document.querySelector('.section-header').offsetHeight;
        }

        // Smooth scroll to the calculated position
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      },
      { signal: controller.signal }
    );
  });
}
